// Iter 650 (Kamel) — sous-dossiers des notes de voyage (espace adhérent + admin)
export const NOTE_CATEGORIES = [
  { id: 'organisation', label: 'Organisation générale', icone: '🗂️', aide: 'Horaires de départ, règlements, formalités, consignes…' },
  { id: 'programme', label: 'Programme & visites', icone: '🗓️', aide: 'Déroulé du séjour, excursions, changements de programme…' },
  { id: 'pratique', label: 'Infos pratiques', icone: '🧳', aide: 'Valise, météo, argent, santé, numéros utiles…' },
  { id: '', label: 'Autres informations', icone: '📌', aide: 'Tout ce qui ne rentre pas ailleurs' },
];

export const categorieNote = (id) => NOTE_CATEGORIES.find(c => c.id === (id || '')) || NOTE_CATEGORIES[NOTE_CATEGORIES.length - 1];

// Regroupe une liste de notes par catégorie, dans l'ordre de NOTE_CATEGORIES (catégories vides ignorées)
export const grouperNotesParCategorie = (notes) =>
  NOTE_CATEGORIES.map(c => ({ ...c, notes: notes.filter(n => (n.categorie || '') === c.id) })).filter(g => g.notes.length > 0);
